// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "maps.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "maps.proto" (syntax proto3)
// tslint:disable
import { Double } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class MatrixRequest$Type extends MessageType {
    constructor() {
        super("MatrixRequest", [
            { no: 1, name: "origins", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Coordinates },
            { no: 2, name: "destination", kind: "message", T: () => Coordinates }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.origins = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Coordinates origins */ 1:
                    message.origins.push(Coordinates.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* Coordinates destination */ 2:
                    message.destination = Coordinates.internalBinaryRead(reader, reader.uint32(), options, message.destination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Coordinates origins = 1; */
        for (let i = 0; i < message.origins.length; i++)
            Coordinates.internalBinaryWrite(message.origins[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Coordinates destination = 2; */
        if (message.destination)
            Coordinates.internalBinaryWrite(message.destination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MatrixRequest
 */
export const MatrixRequest = new MatrixRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DistanceMatrixResponse$Type extends MessageType {
    constructor() {
        super("DistanceMatrixResponse", [
            { no: 1, name: "originAddresses", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "destinationAddresses", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rows", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DistanceMatrixElementRow }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.originAddresses = [];
        message.destinationAddresses = [];
        message.rows = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string originAddresses */ 1:
                    message.originAddresses.push(reader.string());
                    break;
                case /* repeated string destinationAddresses */ 2:
                    message.destinationAddresses.push(reader.string());
                    break;
                case /* repeated DistanceMatrixElementRow rows */ 3:
                    message.rows.push(DistanceMatrixElementRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string originAddresses = 1; */
        for (let i = 0; i < message.originAddresses.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.originAddresses[i]);
        /* repeated string destinationAddresses = 2; */
        for (let i = 0; i < message.destinationAddresses.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.destinationAddresses[i]);
        /* repeated DistanceMatrixElementRow rows = 3; */
        for (let i = 0; i < message.rows.length; i++)
            DistanceMatrixElementRow.internalBinaryWrite(message.rows[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DistanceMatrixResponse
 */
export const DistanceMatrixResponse = new DistanceMatrixResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Place$Type extends MessageType {
    constructor() {
        super("Place", [
            { no: 1, name: "street_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "road_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "zip_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "coords", kind: "message", T: () => Coordinates }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.streetNumber = 0;
        message.roadName = "";
        message.city = "";
        message.state = "";
        message.country = "";
        message.zipCode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 street_number */ 1:
                    message.streetNumber = reader.int32();
                    break;
                case /* string road_name */ 2:
                    message.roadName = reader.string();
                    break;
                case /* string city */ 3:
                    message.city = reader.string();
                    break;
                case /* string state */ 4:
                    message.state = reader.string();
                    break;
                case /* string country */ 5:
                    message.country = reader.string();
                    break;
                case /* string zip_code */ 6:
                    message.zipCode = reader.string();
                    break;
                case /* Coordinates coords */ 7:
                    message.coords = Coordinates.internalBinaryRead(reader, reader.uint32(), options, message.coords);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 street_number = 1; */
        if (message.streetNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.streetNumber);
        /* string road_name = 2; */
        if (message.roadName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.roadName);
        /* string city = 3; */
        if (message.city !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.city);
        /* string state = 4; */
        if (message.state !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.state);
        /* string country = 5; */
        if (message.country !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.country);
        /* string zip_code = 6; */
        if (message.zipCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.zipCode);
        /* Coordinates coords = 7; */
        if (message.coords)
            Coordinates.internalBinaryWrite(message.coords, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Place
 */
export const Place = new Place$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Places$Type extends MessageType {
    constructor() {
        super("Places", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Place }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Place data */ 1:
                    message.data.push(Place.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Place data = 1; */
        for (let i = 0; i < message.data.length; i++)
            Place.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Places
 */
export const Places = new Places$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TripData$Type extends MessageType {
    constructor() {
        super("TripData", [
            { no: 1, name: "distance_in_meters", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "time_in_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.distanceInMeters = 0;
        message.timeInMs = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 distance_in_meters */ 1:
                    message.distanceInMeters = reader.int32();
                    break;
                case /* int64 time_in_ms */ 2:
                    message.timeInMs = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 distance_in_meters = 1; */
        if (message.distanceInMeters !== 0)
            writer.tag(1, WireType.Varint).int32(message.distanceInMeters);
        /* int64 time_in_ms = 2; */
        if (message.timeInMs !== 0n)
            writer.tag(2, WireType.Varint).int64(message.timeInMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TripData
 */
export const TripData = new TripData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TripData_HumanReadableTime$Type extends MessageType {
    constructor() {
        super("TripData.HumanReadableTime", [
            { no: 1, name: "days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "hours", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "display", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.days = 0;
        message.hours = 0;
        message.minutes = 0;
        message.seconds = 0;
        message.display = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 days */ 1:
                    message.days = reader.int32();
                    break;
                case /* int32 hours */ 2:
                    message.hours = reader.int32();
                    break;
                case /* int32 minutes */ 3:
                    message.minutes = reader.int32();
                    break;
                case /* int32 seconds */ 4:
                    message.seconds = reader.int32();
                    break;
                case /* string display */ 5:
                    message.display = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 days = 1; */
        if (message.days !== 0)
            writer.tag(1, WireType.Varint).int32(message.days);
        /* int32 hours = 2; */
        if (message.hours !== 0)
            writer.tag(2, WireType.Varint).int32(message.hours);
        /* int32 minutes = 3; */
        if (message.minutes !== 0)
            writer.tag(3, WireType.Varint).int32(message.minutes);
        /* int32 seconds = 4; */
        if (message.seconds !== 0)
            writer.tag(4, WireType.Varint).int32(message.seconds);
        /* string display = 5; */
        if (message.display !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.display);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TripData.HumanReadableTime
 */
export const TripData_HumanReadableTime = new TripData_HumanReadableTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Coordinates$Type extends MessageType {
    constructor() {
        super("Coordinates", [
            { no: 1, name: "latitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "longitude", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.latitude = 0;
        message.longitude = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double latitude */ 1:
                    message.latitude = reader.double();
                    break;
                case /* double longitude */ 2:
                    message.longitude = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double latitude = 1; */
        if (message.latitude !== 0)
            writer.tag(1, WireType.Bit64).double(message.latitude);
        /* double longitude = 2; */
        if (message.longitude !== 0)
            writer.tag(2, WireType.Bit64).double(message.longitude);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Coordinates
 */
export const Coordinates = new Coordinates$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DistanceMatrixElementRow$Type extends MessageType {
    constructor() {
        super("DistanceMatrixElementRow", [
            { no: 1, name: "distanceMatrixElement", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DistanceMatrixElement }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.distanceMatrixElement = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated DistanceMatrixElement distanceMatrixElement */ 1:
                    message.distanceMatrixElement.push(DistanceMatrixElement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated DistanceMatrixElement distanceMatrixElement = 1; */
        for (let i = 0; i < message.distanceMatrixElement.length; i++)
            DistanceMatrixElement.internalBinaryWrite(message.distanceMatrixElement[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DistanceMatrixElementRow
 */
export const DistanceMatrixElementRow = new DistanceMatrixElementRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DistanceMatrixElement$Type extends MessageType {
    constructor() {
        super("DistanceMatrixElement", [
            { no: 1, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "duration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "durationInTraffic", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "distance", kind: "message", T: () => Distance }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.status = "";
        message.duration = 0n;
        message.durationInTraffic = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string status */ 1:
                    message.status = reader.string();
                    break;
                case /* int64 duration */ 2:
                    message.duration = reader.int64().toBigInt();
                    break;
                case /* int64 durationInTraffic */ 3:
                    message.durationInTraffic = reader.int64().toBigInt();
                    break;
                case /* Distance distance */ 4:
                    message.distance = Distance.internalBinaryRead(reader, reader.uint32(), options, message.distance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string status = 1; */
        if (message.status !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.status);
        /* int64 duration = 2; */
        if (message.duration !== 0n)
            writer.tag(2, WireType.Varint).int64(message.duration);
        /* int64 durationInTraffic = 3; */
        if (message.durationInTraffic !== 0n)
            writer.tag(3, WireType.Varint).int64(message.durationInTraffic);
        /* Distance distance = 4; */
        if (message.distance)
            Distance.internalBinaryWrite(message.distance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DistanceMatrixElement
 */
export const DistanceMatrixElement = new DistanceMatrixElement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Distance$Type extends MessageType {
    constructor() {
        super("Distance", [
            { no: 1, name: "humanReadable", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "meters", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.humanReadable = "";
        message.meters = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string humanReadable */ 1:
                    message.humanReadable = reader.string();
                    break;
                case /* int64 meters */ 2:
                    message.meters = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string humanReadable = 1; */
        if (message.humanReadable !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.humanReadable);
        /* int64 meters = 2; */
        if (message.meters !== 0n)
            writer.tag(2, WireType.Varint).int64(message.meters);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Distance
 */
export const Distance = new Distance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CoordinatesList$Type extends MessageType {
    constructor() {
        super("CoordinatesList", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Coordinates }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Coordinates data */ 1:
                    message.data.push(Coordinates.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Coordinates data = 1; */
        for (let i = 0; i < message.data.length; i++)
            Coordinates.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CoordinatesList
 */
export const CoordinatesList = new CoordinatesList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TravelDistanceRequest$Type extends MessageType {
    constructor() {
        super("TravelDistanceRequest", [
            { no: 1, name: "origin_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "destination_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.originAddress = "";
        message.destinationAddress = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string origin_address */ 1:
                    message.originAddress = reader.string();
                    break;
                case /* string destination_address */ 2:
                    message.destinationAddress = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string origin_address = 1; */
        if (message.originAddress !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.originAddress);
        /* string destination_address = 2; */
        if (message.destinationAddress !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.destinationAddress);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TravelDistanceRequest
 */
export const TravelDistanceRequest = new TravelDistanceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TravelDistance$Type extends MessageType {
    constructor() {
        super("TravelDistance", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "origin_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "destination_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "distance_meters", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "duration_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "computed_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "found", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.originAddress = "";
        message.destinationAddress = "";
        message.distanceMeters = 0;
        message.durationSeconds = 0;
        message.computedAt = "";
        message.isActive = 0;
        message.found = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string origin_address */ 2:
                    message.originAddress = reader.string();
                    break;
                case /* string destination_address */ 3:
                    message.destinationAddress = reader.string();
                    break;
                case /* int32 distance_meters */ 4:
                    message.distanceMeters = reader.int32();
                    break;
                case /* int32 duration_seconds */ 5:
                    message.durationSeconds = reader.int32();
                    break;
                case /* string computed_at */ 6:
                    message.computedAt = reader.string();
                    break;
                case /* int32 is_active */ 7:
                    message.isActive = reader.int32();
                    break;
                case /* bool found */ 8:
                    message.found = reader.bool();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 11:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string origin_address = 2; */
        if (message.originAddress !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.originAddress);
        /* string destination_address = 3; */
        if (message.destinationAddress !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.destinationAddress);
        /* int32 distance_meters = 4; */
        if (message.distanceMeters !== 0)
            writer.tag(4, WireType.Varint).int32(message.distanceMeters);
        /* int32 duration_seconds = 5; */
        if (message.durationSeconds !== 0)
            writer.tag(5, WireType.Varint).int32(message.durationSeconds);
        /* string computed_at = 6; */
        if (message.computedAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.computedAt);
        /* int32 is_active = 7; */
        if (message.isActive !== 0)
            writer.tag(7, WireType.Varint).int32(message.isActive);
        /* bool found = 8; */
        if (message.found !== false)
            writer.tag(8, WireType.Varint).bool(message.found);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 11; */
        if (message.withoutLimit !== false)
            writer.tag(11, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TravelDistance
 */
export const TravelDistance = new TravelDistance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TravelDistanceList$Type extends MessageType {
    constructor() {
        super("TravelDistanceList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TravelDistance },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated TravelDistance results */ 1:
                    message.results.push(TravelDistance.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated TravelDistance results = 1; */
        for (let i = 0; i < message.results.length; i++)
            TravelDistance.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TravelDistanceList
 */
export const TravelDistanceList = new TravelDistanceList$Type();
/**
 * @generated ServiceType for protobuf service MapService
 */
export const MapService = new ServiceType("MapService", [
    { name: "Geocode", options: {}, I: Place, O: Coordinates },
    { name: "DistanceMatrix", options: {}, I: MatrixRequest, O: DistanceMatrixResponse },
    { name: "Elevation", options: {}, I: Coordinates, O: Double },
    { name: "GetDistanceBetweenPlaces", options: {}, I: Places, O: DistanceMatrixResponse },
    { name: "LookupTravelDistance", options: {}, I: TravelDistanceRequest, O: TravelDistance },
    { name: "CreateTravelDistance", options: {}, I: TravelDistance, O: TravelDistance },
    { name: "GetTravelDistance", options: {}, I: TravelDistance, O: TravelDistance },
    { name: "BatchGetTravelDistance", options: {}, I: TravelDistance, O: TravelDistanceList },
    { name: "UpdateTravelDistance", options: {}, I: TravelDistance, O: TravelDistance }
]);
